// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import Header from './Header';
// import Home from './Home';
// import About from './About';
// import Service from './Service';
// import Contact from './Contact';
// import Gallery from './Gallery';
// import Technologies from "./Technologies"
// import reportWebVitals from './reportWebVitals';
// import ScrollToTopButton from './ScrollToTopButton';


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <Header />
//       <Routes>
//         <Route path='/' element={<Home />} />
//         <Route path='/about' element={<About />} />
//         <Route path='/service' element={<Service />} />
//         <Route path='/techno' element={<Technologies />} />
//         <Route path='/contact' element={<Contact />} />
//         <Route path='/gallery' element={<Gallery />} />
//       </Routes>
//       <ScrollToTopButton />
//     </BrowserRouter>
//   </React.StrictMode>
// );

// reportWebVitals();
/**/ 
// import React, { useEffect } from 'react';
// import ReactDOM from 'react-dom/client';
// import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'; 

// // AOS Animation Imports
// import AOS from 'aos';
// import 'aos/dist/aos.css';

// // Your Component Imports
// import Header from './Header';
// import Home from './Home';
// import About from './About';
// import Service from './Service';
// import Contact from './Contact';
// import Gallery from './Gallery';
// import Technologies from "./Technologies";
// import ScrollToTopButton from './ScrollToTopButton';
// import reportWebVitals from './reportWebVitals'
// import Footer from './Footer';
// // import Chatbot from './Chatbot';// Create a wrapper component to handle AOS initialization

// const ScrollToTop = () => {
//   const { pathname } = useLocation();
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);
//   return null;
// };

// const RootApp = () => {
//   useEffect(() => {
//     // AOS Initialize
//     AOS.init({
//       duration: 1000,     
//       once: false,         
//       easing: 'ease-out-cubic', 
//       offset: 100,  
         
//     });
    
//   }, []);

//   return (
//     <BrowserRouter>
//     <ScrollToTop/>
//       <Header />
//       <Routes>
//         <Route path='/' element={<Home />} />
//         <Route path='/about' element={<About />} />
//         <Route path='/service' element={<Service />} />
//         <Route path='/techno' element={<Technologies />} />
//         <Route path='/contact' element={<Contact />} />
//         <Route path='/gallery' element={<Gallery />} />
//       </Routes>
//       <Footer/>
//       <ScrollToTopButton />
//       {/* <Chatbot/> */}
//     </BrowserRouter>
//   );
// };

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <RootApp />
//   </React.StrictMode>
// );

// reportWebVitals();

/*smooth scroll*/
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';

import AOS from 'aos';
import 'aos/dist/aos.css';
import Lenis from '@studio-freight/lenis';

import Header from './Header';
import Home from './Home';
import About from './About';
import Service from './Service';
import Contact from './Contact';
import Gallery from './Gallery';
import Technologies from "./Technologies";
import ScrollToTopButton from './ScrollToTopButton';
import reportWebVitals from './reportWebVitals';
import Footer from './Footer';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.documentElement.scrollTo({ top: 0, behavior: 'instant' });
    document.body.scrollTo({ top: 0, behavior: 'instant' });
    setTimeout(() => AOS.refresh(), 150);
  }, [pathname]);
  return null;
};

const lenis = new Lenis({
  duration: 1.4,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  smooth: true,
  smoothTouch: false,
  syncTouch: false,
});

window.__lenis = lenis;

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

const RootApp = () => {
  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
      easing: 'ease-out-cubic',
      offset: 0,
    });

    lenis.on('scroll', () => {
      AOS.refresh();
    });
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/service' element={<Service />} />
        <Route path='/techno' element={<Technologies />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/gallery' element={<Gallery />} />
      </Routes>
      <Footer />
      <ScrollToTopButton />
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);

reportWebVitals();